export default class PageType {
  static pageTypes = [
    'common',
    'building',
    'photo',
    'heat',
    'emobil',
  ];

  static getById(pageTypeId: number | string): string {
    const inx = parseInt(`${pageTypeId}`, 10);

    if (typeof this.pageTypes[inx] !== 'undefined') {
      return this.pageTypes[inx];
    }

    return 'other';
  }
}
